import axios from 'axios';

export function createRequest(baseURL = '', options) {
  return axios.create({
    baseURL,
    ...options,
  });
}

export const baseURL = window.location.origin;

const options = {
  withCredentials: true,
  // `xsrfCookieName` is the name of the cookie to use as a value for xsrf token
  xsrfCookieName: 'csrftoken',
  // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
  xsrfHeaderName: 'X-CSRFToken',
};
const request = createRequest(baseURL, options);

export default request;
